function isObjectEmpty(obj) {
  if (!obj) return true // 👈 null and undefined check

  return obj && Object.keys(obj).length === 0 && Object.getPrototypeOf(obj) === Object.prototype
}

export default isObjectEmpty
